module.exports = __webpack_public_path__ + "img/flower-group-1.14befe2.svg";